import Vue from "vue";
import VueRouter from "vue-router";
import {Message} from 'element-ui'

Vue.use(VueRouter);
const Home = () => import("@/views/home/Home");

const routes = [{
  path: "/",
  name: "home",
  component: Home,
  redirect: 'index',
  children: [{
    path: 'index',
    name: 'index',
    component: () => import('@/views/home/Index')
  }, {
    path: "/resource",
    name: "resource",
    component: () => import("@/views/resource/index.vue"),
    redirect: '/resource/inbook',
    children: [{
      path: '/resource/inbook',
      name: 'inbook',
      component: () => import('@/views/resource/main/inBooks.vue')
    }, {
      path: '/resource/author',
      name: 'author',
      component: () => import('@/views/resource/main/author.vue')
    }, {
      path: '/resource/video',
      name: 'video',
      component: () => import('@/views/resource/main/video.vue')
    }, {
      path: '/resource/audio',
      name: 'audio',
      component: () => import('@/views/resource/main/audio.vue')
    }, {
      path: '/resource/image',
      name: 'image',
      component: () => import('@/views/resource/main/image.vue')
    }, {
      path: '/resource/all',
      name: 'all',
      component: () => import('@/views/resource/main/all.vue')
    }]
  }, {
    path: '/resource/detail',
    name: 'detail',
    component: () => import('@/views/resource/details.vue')
  },
    {
      path: '/resource/videoshows',
      name: 'detailshow',
      component: () => import('@/views/resource/detailShows.vue')
    },
    {
      path: '/resource/detailsAud',
      name: 'detailsAud',
      component: () => import('@/views/resource/detailsAud.vue')
    },
    {
      path: 'news',
      name: 'news',
      component: () => import('@/views/news/News')
    },
    {
      path: 'newsdetails',
      name: 'newsdetails',
      component: () => import('@/views/news/NewsDetails')
    },
    {
      path: 'reader',
      name: 'reader',
      component: () => import('@/views/reader/ReaderIndex'),
      beforeEnter: (to, from, next) => {
        if (!sessionStorage.getItem("portal_user_info")) {
          Message({
            message: '请登录',
            type: 'error'
          })
        } else{
          next()
        }
      }
    },
    {
      path: 'buying',
      name: 'buying',
      component: () => import('@/views/buying/index')
    },
    {
      path: 'diction',
      name: 'diction',
      component: () => import('@/views/diction/index')
    }]
},
  {
    path: "/exhibition",
    name: "exhibition",
    component: () => import("@/views/exhibition/index"),
    beforeEnter: (to, from, next) => {
      if (!sessionStorage.getItem("portal_user_info")) {
        Message({
          message: '请登录',
          type: 'error'
        })
      } else if (to.query.bookId && to.query.page) {
        next()
      }
    }
  },
  {
    path: "/dd",
    name: "dd",
    component: () => import("@/views/home/dd"),
  },
  {
    path: "/canvas",
    name: "canvas",
    component: () => import("@/views/home/canvas"),
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/views/404/404"),
  },
];

const router = new VueRouter({
  routes,
  base: "/gxwk",
});


const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return routerPush.call(this, location).catch((error) => error);
};

export default router;
